/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AdminDatasetCategory = {
  id: 'admin-dataset-category.get',
  tag: 'Admin',
  summary: 'Admin Dataset Category',
  description: 'Get all dataset categories',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => '/administration/dataset-category',
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.Id,
              identifier: z.string(),
              createdAt: z.date(),
              updatedAt: z.date(),
              thumbnail: z.any(),
              i18n: z.optional(
                z.array(
                  z.strictObject({
                    title: z.string(),
                    language: ZodTypes.Language,
                  }),
                ),
              ),
              datasets: z.any(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
